export default "__VITE_PUBLIC_ASSET__3509ea18__"